import { render, staticRenderFns } from "./articlePool.vue?vue&type=template&id=6a311c3d&scoped=true&"
import script from "./articlePool.vue?vue&type=script&lang=js&"
export * from "./articlePool.vue?vue&type=script&lang=js&"
import style0 from "./articlePool.vue?vue&type=style&index=0&id=6a311c3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a311c3d",
  null
  
)

export default component.exports